import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { breakpoints } from '../../theme';

export const Wrapper = styled(Grid)`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down(breakpoints.tablet)} {
    align-items: center;
  }
`;
